import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { portalApi, portalError } from "./portalApi";
import { Btn, Input, Empty } from "../components/UI";
import { Plus, Trash2, Bell, CheckCircle2, Circle } from "lucide-react";
import { toast } from "sonner";

export default function PortalTasks() {
  const [todos, setTodos] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [title, setTitle] = useState("");
  const [due, setDue] = useState("");

  const load = () => {
    portalApi.get("/portal/todos").then((r) => setTodos(r.data));
    portalApi.get("/portal/notifications").then((r) => setNotifications(r.data));
  };
  useEffect(() => { load(); portalApi.post("/portal/notifications/read").catch(() => {}); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await portalApi.post("/portal/todos", { title, due_date: due });
      setTitle(""); setDue(""); load();
    } catch (err) { toast.error(portalError(err)); }
  };
  const toggle = async (t) => {
    await portalApi.put(`/portal/todos/${t.id}`, { status: t.status === "open" ? "done" : "open" });
    load();
  };
  const remove = async (t) => {
    try { await portalApi.delete(`/portal/todos/${t.id}`); load(); }
    catch (err) { toast.error(portalError(err)); }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid="portal-tasks-page">
      <div>
        <h1 className="font-heading text-xl font-bold text-[#3E2723] mb-1">My To-Dos</h1>
        <p className="text-sm text-[#7B6157] mb-4">Personal tasks & anything your care team asked you to do.</p>
        <form onSubmit={add} className="flex gap-2 mb-4">
          <Input data-testid="portal-todo-title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Add a to-do…" required className="flex-1" />
          <Input data-testid="portal-todo-due" type="date" value={due} onChange={(e) => setDue(e.target.value)} className="w-40" />
          <Btn data-testid="portal-todo-add" type="submit" className="px-3"><Plus size={15} /></Btn>
        </form>
        {todos.length === 0 ? <Empty text="Nothing on your list" /> : (
          <div className="space-y-2">
            {todos.map((t) => (
              <div key={t.id} className={`flex items-center gap-3 rounded-xl bg-white border border-[#EFEBE0] px-4 py-3 ${t.status === "done" ? "opacity-60" : ""}`} data-testid={`portal-todo-${t.id}`}>
                <button data-testid={`portal-todo-toggle-${t.id}`} onClick={() => toggle(t)} className="shrink-0">
                  {t.status === "done" ? <CheckCircle2 size={19} className="text-[#2E7D32]" /> : <Circle size={19} className="text-[#D7CCC8]" />}
                </button>
                <div className="min-w-0">
                  <div className={`text-sm font-semibold text-[#3E2723] ${t.status === "done" ? "line-through" : ""}`}>{t.title}</div>
                  {t.due_date && <div className="text-[11px] text-[#84675B]">Due {dayjs(t.due_date).format("MMM D, YYYY")}</div>}
                  {t.source === "staff" && <span className="text-[10px] font-bold text-[#5E35B1]">From your care team</span>}
                </div>
                {t.source !== "staff" && (
                  <button data-testid={`portal-todo-delete-${t.id}`} onClick={() => remove(t)} className="ml-auto p-1.5 text-[#C62828] hover:bg-[#FFEBEE] rounded-lg"><Trash2 size={14} /></button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        <h2 className="font-heading text-xl font-bold text-[#3E2723] mb-1 flex items-center gap-2"><Bell size={18} className="text-[#7B6157]" /> Reminders & Messages</h2>
        <p className="text-sm text-[#7B6157] mb-4">Appointment reminders, refill updates and clinic messages.</p>
        {notifications.length === 0 ? <Empty text="No messages yet" /> : (
          <div className="space-y-2 max-h-[520px] overflow-y-auto pr-1">
            {notifications.map((n) => (
              <div key={n.id} className="rounded-xl bg-white border border-[#EFEBE0] px-4 py-3" data-testid={`portal-notif-${n.id}`}>
                <div className="text-sm font-semibold text-[#3E2723]">{n.subject}</div>
                <div className="text-xs text-[#6D4C41] mt-0.5">{n.message}</div>
                <div className="text-[10px] text-[#84675B] mt-1">{dayjs(n.created_at).format("MMM D, YYYY · h:mm A")}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
